import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Star } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center px-6 py-12 overflow-hidden bg-[#1C1C2E] text-[#F5F0E8]" data-id="element-78">
      {/* Ambient Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[500px] bg-[radial-gradient(circle_at_center,rgba(212,165,116,0.15)_0%,transparent_70%)] pointer-events-none" data-id="element-79" />

      {/* Stars Decoration */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 0.6
    }} transition={{
      duration: 2,
      repeat: Infinity,
      repeatType: 'reverse'
    }} className="absolute top-20 left-10 text-[#D4A574]" data-id="element-80">
        <Star size={16} fill="#D4A574" data-id="element-81" />
      </motion.div>
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 0.4
    }} transition={{
      duration: 3,
      delay: 1,
      repeat: Infinity,
      repeatType: 'reverse'
    }} className="absolute top-40 right-12 text-[#D4A574]" data-id="element-82">
        <Star size={12} fill="#D4A574" data-id="element-83" />
      </motion.div>

      <div className="relative z-10 max-w-3xl mx-auto text-center space-y-8" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="flex justify-center mb-6" data-id="element-85">
          <Moon className="w-12 h-12 text-[#D4A574]" strokeWidth={1.5} data-id="element-86" />
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight text-white" data-id="element-87">
          Tu hijo no necesita{' '}
          <span className="text-[#D4A574] italic" data-id="element-88">otra rutina</span>.{' '}
          <br className="hidden md:block" data-id="element-89" />
          Necesita un cierre que se acorte.
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="space-y-6 text-lg md:text-xl text-[#F5F0E8]/90 leading-relaxed max-w-2xl mx-auto" data-id="element-90">
          <p data-id="element-91">
            Son las 10 y pico. Ya hiciste pijama, dientes, pipí, cuento, otro
            cuento "cortito", agua, otro abrazo… y aún así tu hijo sigue:
          </p>
          <p className="font-serif italic text-2xl text-[#D4A574]" data-id="element-92">
            "Una cosa más."
          </p>
          <p data-id="element-93">
            Y vos sentís esa mezcla horrible de cansancio + culpa + bronca.
            Porque no querés gritar. Pero tampoco podés vivir así.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="mt-12" data-id="element-94">
          <div className="relative mx-auto w-full max-w-md rounded-2xl overflow-hidden shadow-[0_0_40px_-10px_rgba(212,165,116,0.3)] border border-[#D4A574]/20" data-id="element-95">
            <img src="https://cdn.magicpatterns.com/uploads/ooTwjZ6bHbbJPMEJcKhMus/PORTADA_DORMI_HOY.png" alt="Dormí Hoy Protocolo en tablet sobre mesa de luz" className="w-full h-auto object-cover" data-id="element-96" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1C1C2E] via-transparent to-transparent opacity-40" data-id="element-97" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="pt-8" data-id="element-98">
          <a href="#pricing" className="inline-block bg-[#D4A574] hover:bg-[#C39363] text-[#1C1C2E] font-semibold text-lg px-8 py-4 rounded-full transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(212,165,116,0.4)]" data-id="element-99">
            Quiero recuperar mis noches
          </a>
          <p className="mt-4 text-sm text-[#F5F0E8]/60" data-id="element-100">
            Protocolo de 7 noches para padres de chicos de 4–5 años
          </p>
        </motion.div>
      </div>
    </section>;
}